import { API_URLS } from "../../config/apiUrls";
import axiosInstance from "../../config/axios";

export const getTypeFive = (reqBody) => {
  try {
    const response = axiosInstance.get(API_URLS.screensizeVariantApi, {
      params: reqBody,
    });
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};

export const getTypefiveCategory = (reqBody) => {
  try {
    const response = axiosInstance.get(API_URLS.screensizeTypeApi, {
      data: reqBody,
    });
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};

export const addTypefiveCategory = (reqBody) => {
  try {
    const response = axiosInstance.post(API_URLS.screensizeTypeApi, reqBody);
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};

export const updateTypefiveCategory = (reqBody) => {
  try {
    const response = axiosInstance.put(API_URLS.screensizeTypeApi, reqBody);
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};

export const deleteTypefiveCategory = (reqBody) => {
  try {
    const response = axiosInstance.delete(API_URLS.screensizeTypeApi, {
      data: reqBody,
    });
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};

export const addTypeFive = (reqBody) => {
  try {
    const response = axiosInstance.post(API_URLS.screensizeVariantApi, reqBody);
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};

export const deleteTypeFive = (reqBody) => {
  try {
    const response = axiosInstance.delete(API_URLS.screensizeVariantApi, {
      data: reqBody,
    });
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};

export const updateTypeFive = (reqBody) => {
  try {
    const response = axiosInstance.put(API_URLS.screensizeVariantApi, reqBody);
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};
